var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Handlebars = (function (obj) {
		var compiledPartials = Object.create({});

		obj.register = function (partials) {
			if (typeof(partials) === 'undefined' || partials.length === 0)
				throw new Error("Vendd.Handlebars.registerHandlebarsTemplate: no templates provided.");

			if (typeof(Handlebars) !== "object")
				throw new Error("Vendd.Handlebars.registerHandlebarsTemplate: Handlebars is not available.");

			if (Array.isArray(partials)) {
				partials.forEach(function (partial) {
					if (partial.hasOwnProperty('Key') && partial.hasOwnProperty('Value') && Handlebars.partials.hasOwnProperty(partial.Key) === false) {
						Handlebars.registerPartial(partial.Key, partial.Value);
					};
				});
			} else {
			    if (partials.hasOwnProperty('Key') && partials.hasOwnProperty('Value') && Handlebars.partials.hasOwnProperty(partials.Key) === false) {
			        Handlebars.registerPartial(partials.Key, partials.Value);
				};
			};
		};

		obj.isRegistered = function (partialName) {
			if (Handlebars.partials.hasOwnProperty(partialName))
				return true;

			return false;
		};

		obj.compile = function (partialName) {
			var compiledPartial;

			if (typeof(Handlebars) !== "object")
				throw new Error("Vendd.Handlebars.compileHandlebarsPartial: Handlebars is not available.")

			if (typeof(Handlebars.partials[partialName]) === 'undefined')
				throw new Error("Vendd.Handlebars.compileHandlebarsPartial: Partial " + partialName + " is not registered.");

			if (compiledPartials.hasOwnProperty(partialName)) {
				compiledPartial = compiledPartials[partialName];
			} else {
				compiledPartial = Handlebars.compile(Handlebars.partials[partialName]);

				compiledPartials[partialName] = compiledPartial;
			};

			return compiledPartial;
		};

		obj.parse = function (partial, model) {
			if (typeof(Handlebars) !== "object")
				throw new Error("Vendd.Handlebars.parseHandlebarsPartial: Handlebars is not available.");

			if (typeof (partial) === "string")
			    partial = Handlebars.partials[partial]; 

			if (typeof(partial) !== "function")
				throw new Error("Vendd.Handlebars.parseHandlebarsPartial: Partial " + partial + " is not a valid compiled Handlebars partial.");

			if (typeof(model) !== "object")
				throw new Error("Vendd.Handlebars.parseHandlebarsPartial: Model is not valid.");

			var parsed = partial(model);

			return parsed;
		};

		return obj;

	})(Vendd.Handlebars || {});

	return Vendd;

})(Vendd || {});